import type { StoreAdditionalInfoData } from "@hitit/api";

//Korean Register Additional Info key

export const KO_REGISTRATION_LINKED_CASHRECEIPT_MEMBERSHIP = `KO_REGISTRATION_LINKED_CASHRECEIPT_MEMBERSHIP`
export const KO_IS_CASH_RECEIPT_AVAILABLE = `KO_IS_CASH_RECEIPT_AVAILABLE`;
export const KO_REGISTRATION_NUMBER = `KO_REGISTRATION_NUMBER`;
export const KO_REGISTRATION_FILE_ADDR = `KO_REGISTRATION_FILE_ADDR`
export const KO_OWNER_NAME = `KO_OWNER_NAME`
export const KO_REGISTRATION_STORETYPE = `KO_REGISTRATION_STORETYPE`
export const KO_REGISTRATION_STORENAME = `KO_REGISTRATION_STORENAME`
export const KO_REGISTRATION_STORECLASS = `KO_REGISTRATION_STORECLASS`
export const KO_REGISTRATION_STORE_ADDR = `KO_REGISTRATION_STORE_ADDR`
export const KO_REGISTRATION_CONTACTNAME = `KO_REGISTRATION_CONTACTNAME`
export const KO_REGISTRATION_CONTACTEMAIL = `KO_REGISTRATION_CONTACTEMAIL`;
export const KO_REGISTRATION_CONTACTNUMBER = `KO_REGISTRATION_CONTACTNUMBER`;
export const KO_IS_MOBILE_PAYMENT_AVAILABLE = "KO_IS_MOBILE_PAYMENT_AVAILABLE"
export const additionalInfoKey = [
	KO_REGISTRATION_LINKED_CASHRECEIPT_MEMBERSHIP,
	KO_IS_CASH_RECEIPT_AVAILABLE,
	KO_REGISTRATION_NUMBER,
	KO_REGISTRATION_FILE_ADDR,
	KO_OWNER_NAME,
	KO_REGISTRATION_STORETYPE,
	KO_REGISTRATION_STORENAME,
	KO_REGISTRATION_STORECLASS,
	KO_REGISTRATION_STORE_ADDR,
	KO_REGISTRATION_CONTACTNAME,
	KO_REGISTRATION_CONTACTEMAIL,
	KO_REGISTRATION_CONTACTNUMBER,
	KO_IS_MOBILE_PAYMENT_AVAILABLE
]
export const approvalRequired = [
	KO_REGISTRATION_NUMBER,
	KO_REGISTRATION_FILE_ADDR,
	KO_OWNER_NAME,
	KO_REGISTRATION_STORETYPE,
	KO_REGISTRATION_STORENAME,
	KO_REGISTRATION_STORECLASS,
	KO_REGISTRATION_STORE_ADDR,
	KO_REGISTRATION_CONTACTNAME,
	KO_REGISTRATION_CONTACTEMAIL,
	KO_REGISTRATION_CONTACTNUMBER,
]

export const approvalRequiredLabels: Record<string, string> = {
	KO_REGISTRATION_NUMBER: "사업자 번호",
	KO_REGISTRATION_FILE_ADDR: "사업자등록증 첨부파일",
	KO_OWNER_NAME: "대표자 성명",
	KO_REGISTRATION_STORETYPE: "업태",
	KO_REGISTRATION_STORENAME: "상호명",
	KO_REGISTRATION_STORECLASS: "종목",
	KO_REGISTRATION_STORE_ADDR: "사업장 주소",
	KO_REGISTRATION_CONTACTNAME: "담당자 성명",
	KO_REGISTRATION_CONTACTEMAIL: "담당자 이메일",
	KO_REGISTRATION_CONTACTNUMBER: "담당자 번호",
};


export function addAdditionalInfo(
	storeAdditionalInfoDTOList: StoreAdditionalInfoData[]
) {
	const nonExistentKeys = additionalInfoKey.filter(
		(v) => {
			const find = storeAdditionalInfoDTOList.find((info) => info.key === v);
			return find === undefined
		}
	);

	const noneExistentInfo = nonExistentKeys.map((v) => ({
		key: v,
		value: "",
	}))

	return [...storeAdditionalInfoDTOList, ...noneExistentInfo] as StoreAdditionalInfoData[]
}